EventEmitter = require('backbone').Events
ListComponent = require 'views/enterprise/dashboard/list-component'
PaginatedLoaders = require 'views/enterprise/dashboard/paginated-loaders'
{ FilterStringBuilder, SimpleFilterStringBuilder } = require 'views/enterprise/dashboard/filter-string-builder'
Promise = require 'bluebird'
RenderableItems = require 'views/enterprise/dashboard/renderable-items'
_ = require 'underscore'

{ LOADED, LOADING_NEW, LOADING_NEXT, LOADING_ERROR } =
  ListComponent.LOADING_STATES

module.exports.Paginated = class PaginatedItemList
  _.extend @::, EventEmitter

  DEFAULT_SORT_FIELD: ''
  DEFAULT_SORT_ORDER: 'ascending'

  constructor: (enterprise) ->
    @enterprise = enterprise

    @filterStringBuilder = @_newFilterStringBuilder()
    @sortField = @DEFAULT_SORT_FIELD
    @sortOrder = @DEFAULT_SORT_ORDER

    @loadingState = LOADING_NEW
    @_mainPaginatedList = @_newMainPaginatedList()
    @paginatedList = @_mainPaginatedList

    @resetState().tap (models) =>
      @trigger('loadFirst', @)

  _newPaginatedLoader: (args...) ->
    new PaginatedLoaders.PaginatedLoader(args...)

  _newFilterStringBuilder: (args...) ->
    new FilterStringBuilder(args...)

  _newRenderable: (args...) ->
    new RenderableItems.Renderable(args...)

  _newMainPaginatedList: ->
    @_newPaginatedLoader @enterprise

  _newFilteredPaginatedList: ->
    @_newPaginatedLoader @enterprise, {
      @filterStringBuilder
      @sortField
      @sortOrder
    }

  _modelList: ->
    []

  resetState: ->
    @rerender()
    @filterStringBuilder.clearAll()
    @updateFilter('search', "")

  remove: (renderable) ->
    @paginatedList.remove(renderable)
    if @_mainPaginatedList != @paginatedList
      @_mainPaginatedList.remove(renderable)
    if @incomingPaginatedList not in [@paginatedList, @_mainPaginatedList]
      @incomingPaginatedList?.remove(renderable)
    @rerender()


  rerender: ->
    @renderables = {}
    for model in @_modelList()
      renderable = @_newRenderable(model)
      @renderables[renderable.id] = renderable

  rerenderItem: (renderable) ->
    model = _.find @_modelList(), (model) -> model.get('id') == renderable.id
    newRenderable = @_newRenderable(model)
    @renderables[renderable.id] = newRenderable

  _isUsingDefaultSorting: ->
    @sortField == @DEFAULT_SORT_FIELD && \
      @sortOrder == @DEFAULT_SORT_ORDER

  _isUsingMainList: ->
    @filterStringBuilder.getActiveFilters().length == 0 && \
      @_isUsingDefaultSorting()

  search: ->
    @incomingPaginatedList?.abortLoad()

    if @_isUsingMainList()
      @incomingPaginatedList = @_mainPaginatedList
      # Upon instantiation we'll do the search for the main list, then
      # subsequently it'll already be ready to use.
      if @incomingPaginatedList.totalLength > 0
        @_swapInNewList()
        @loadingState = LOADED
        @trigger('loadingStateChanged', @)
        return Promise.resolve([])
    else
      @incomingPaginatedList = @_newFilteredPaginatedList()
    @loadNextPage()

  sort: (field, order) ->
    @sortField = field
    @sortOrder = order
    @search()

  getSortField: ->
    @sortField

  getSortOrder: ->
    @sortOrder

  updateFilter: (type, value) ->
    @filterStringBuilder.update(type, value)
    @search()

  toggleFilter: (type, value) ->
    @filterStringBuilder.toggle(type, value)
    @search()

  clearFilter: (type) ->
    @filterStringBuilder.clear(type)
    @search()

  getFilterValueMap: ->
    @filterStringBuilder.getState()

  getActiveFilters: ->
    @filterStringBuilder.getActiveFilters()

  _addLoadedRenderables: (models) ->
    for m in models when !@renderables[m.get('id')]?
      renderable = @_newRenderable(m)
      renderable.selected = @paginatedList.loadAsSelected
      @renderables[renderable.id] = renderable

  _swapInNewList: ->
    return if @paginatedList == @incomingPaginatedList
    @paginatedList = @incomingPaginatedList
    @deselectAllItems()

  loadNextPage: ->
    return Promise.resolve([]) unless @incomingPaginatedList.hasNext
    if @incomingPaginatedList == @paginatedList
        @loadingState = LOADING_NEXT
        @trigger('loadingStateChanged', @)
    else
        @loadingState = LOADING_NEW
        @trigger('loadingStateChanged', @)
    @incomingPaginatedList.loadNext()
      .tap (models) =>
        @_addLoadedRenderables(models)
        @_swapInNewList()
        @loadingState = LOADED
        @trigger('loadingStateChanged', @)
      .catch Promise.CancellationError, (->)
      .catch (err) =>
        @_swapInNewList()
        @loadingState = LOADING_ERROR
        @trigger('loadingStateChanged', @)

  hasNextPage: ->
    @paginatedList.hasNext

  items: ->
    _.chain @paginatedList.items
      .map (item) =>
        @renderables[item.get('id')]
      .compact()
      .value()

  deselectAllItems: ->
    _.forEach @renderables, (model) -> model.selected = false

  itemSelected: (newlySelectedItem, selectRange) ->
    return if newlySelectedItem == @previousSelectedItem

    if selectRange && @previousSelectedItem?
      items = @items()
      indexOfNew = items.indexOf(newlySelectedItem)
      indexOfPrevious = items.indexOf(@previousSelectedItem)
      for i in [indexOfNew..indexOfPrevious]
        items[i].selected = newlySelectedItem.selected
      return

    @previousSelectedItem = newlySelectedItem

  selectedItemsLength: ->
    result = @_selectedRenderables().length
    if @paginatedList.loadAsSelected
      result += @paginatedList.lengthOfPending
    result

  _selectedRenderables: ->
    _.filter @items(), (model) ->
      model.selected

  selectedItems: ->
    if !@paginatedList.loadAsSelected
      Promise.resolve(@_selectedRenderables())
    else
      @paginatedList.loadAll(@_addLoadedRenderables.bind(@))
      .then =>
        @loadingState = LOADED
        @trigger('loadingStateChanged', @)
        @_selectedRenderables()

  _setSelected: (value) ->
    return unless @paginatedList?
    @paginatedList.loadAsSelected = value

    for toMark in @items()
      toMark.selected = value

  selectAll: ->
    @_setSelected(true)

  deselect: ->
    @_setSelected(false)

  lengthOfSearch: -> @paginatedList.totalLength
  lengthOfLoaded: -> @paginatedList.items.length
  totalLength: -> @_mainPaginatedList.totalLength

module.exports.Member = class MemberItemList extends PaginatedItemList

  DEFAULT_SORT_FIELD: 'fullName'

  _newPaginatedLoader: (args...) ->
    new PaginatedLoaders.Members(args...)

  _newFilterStringBuilder: (args...) ->
    new FilterStringBuilder(RenderableItems.Member::API_SEARCH_FIELDS, args...)

  _newRenderable: (model) ->
    new RenderableItems.Member(model)

  _modelList: ->
    @enterprise.memberList.models

module.exports.Organization = class OrganizationItemList extends PaginatedItemList

  DEFAULT_SORT_FIELD: 'displayName'

  _newPaginatedLoader: (args...) ->
    new PaginatedLoaders.Organizations(args...)

  _newFilterStringBuilder: (args...) ->
    new FilterStringBuilder(RenderableItems.Organization::API_SEARCH_FIELDS, args...)

  _newRenderable: (model) ->
    new RenderableItems.Organization(model)

  _modelList: ->
    @enterprise.organizationList.models

# Per-member organizations lists that always filter for that member
module.exports.OrganizationForMember = class OrganizationItemListForMember extends OrganizationItemList
  constructor: (enterprise, member) ->
    @member = member
    super(enterprise)

  _newMainPaginatedList: ->
    @_newFilteredPaginatedList()

  _isUsingMainList: ->
    @filterStringBuilder.getActiveFilters().length == 1 &&
      @_isUsingDefaultSorting()

  resetState: ->
    @rerender()
    @filterStringBuilder.clearAll()
    @filterStringBuilder.update('members', @member.get('id'))
    @updateFilter('search', "")

module.exports.PendingOrganization = class PendingOrganizationItemList extends PaginatedItemList

  DEFAULT_SORT_FIELD: 'displayName'

  _newPaginatedLoader: (args...) ->
    new PaginatedLoaders.PendingOrganizations(args...)

  _newFilterStringBuilder: (args...) ->
    new SimpleFilterStringBuilder(RenderableItems.PendingOrganization::API_SEARCH_FIELDS, args...)

  _newRenderable: (model) ->
    new RenderableItems.PendingOrganization(model)

  _modelList: ->
    @enterprise.pendingOrganizationList.models



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/item-list.coffee